import { useEffect } from 'react';

export const titler = title => {
  useEffect(() => {
    document.title = title + ' | FantaClasse';
  }, []);
};
